import { PrivateSite } from '../private-site/PrivateSite';
export function VisitorsUploads(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  return new PrivateSite({
    ...userSettings,
    name: 'visitors-uploads',
    sourceName: 'visitorsUploads'
  });
}